export default __webpack_public_path__ + "static/media/tableshow.fc18ca0c.svg";